/******************************************************
 *                  Open-iti import
 ********************************************************/

"use strict";

angular.module("open-iti")

	.controller("OpenPublicationCtrlParent", [
		"$scope", "OpenPublicationService", "Utils", "$uibModal", "toastr", "$location",
		function ($scope, OpenPublicationService, Utils, $uibModal, toastr, $location) {

		var deleteModal;
		$scope.data = {};

		/**
         * Ouvrir la modal de suppression d'une publication.
         */
		$scope.openDeleteModal = function (publication) {
			$scope.data.publicationToDelete = publication;
			deleteModal = Utils.openModal($uibModal, "delete.html", $scope);
		};

		/**
       * Supprimer une publication
       * @param publicationInfo contient les informations d'une publication à supprimer
       */
		$scope.deletePublication = function (publicationInfo) {
			OpenPublicationService.deletePublication(publicationInfo).then(() => {
				toastr.success("La publication du réseau " + publicationInfo.networkName + " a bien été supprimée.", "Publication supprimée");
				deleteModal.close();
				if ($scope.data.detailMode) {
					$location.path("open-iti/publication");
				} else {
					OpenPublicationService.getPublications().then((response) => {
						$scope.data.publications = resposne.data;
					});
				}
			}).catch((error) => {
				const data = error.data;
				let errorMessage = "Problème lors de la suppression de votre publication.";
				if (data !== undefined && data.message) {
					errorMessage += data.message;
				}
				toastr.error(errorMessage, "Erreur");
			});
		};




		$scope.downloadDataFile = function (exportData) {

			// Récupérer le nom du fichier de données.
			var dataFileName;
			for (var linkIndex in exportData.links) {
				var link = exportData.links[linkIndex];
				if (link.rel === "data") {
					dataFileName = link.href.substr(link.href.lastIndexOf("/") + 1);
					break;
				}
			}

			if (dataFileName !== undefined) {
				OpenPublicationService.getExportDataFile(exportData.referential, exportData.id, dataFileName)
					.then((response) => {
						var blob = new Blob([response.data], {type: "octet/stream"});
						var a = document.createElement("a");
						a.href =  (window.URL || window.webkitURL).createObjectURL(blob);
						a.target = "_blank";
						a.download = dataFileName;
						document.body.appendChild(a);
						a.click();

					});
			} else {
				toastr.error("Le fichier est introuvable sur le serveur.", "Problème lors du téléchargement");
			}
		};



	}]);
